import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { fetchCompetitorsSobComment } from 'partner360/services/competitorsSob/fetchCompetitorsSobComment'

import { REQUEST_COMPETITORS_SOB_COMMENT } from '../constants'
import { selectCompetitorsSobState } from '../selectors/selectCompetitorsSobState'

export const requestSobCompetitorsComment = createAsyncThunk(
  REQUEST_COMPETITORS_SOB_COMMENT,
  fetchCompetitorsSobComment,
  {
    condition({ partnerId, fYear, programType }, { getState }) {
      if (!partnerId || !fYear || !programType) {
        return false
      }

      const state = getState()
      const competitorsState = selectCompetitorsSobState(state)
      if (
        competitorsState.fYear === fYear &&
        competitorsState.partnerId === partnerId &&
        competitorsState.data[programType]?.length
      ) {
        return false
      }

      return true
    },
  }
)
